export default "__VITE_ASSET__6b4c1fcd__"